import React, { } from "react";
import useIntersectionObserver from "./home-animation";
export default function HomeConnecting() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <div className="home-connecting">
            <div className="home-connecting-overlay"></div>
            <div className="outer-container">
                <div className="home-counter-row position-relative">
                    <div className={`home-counter-div  ${isVisible1 ? 'animate__fadeIn' : ''}`}  style={{ animationDuration: '1.25s' }}  ref={sectionRef1}>
                    <div className="connecting-head">Connecting Talent with Opportunity</div>
                        <p className="main-para text-white connecting-para">We specialize in matching skilled individuals with the right career opportunities. Our platform ensures seamless connections that drive success for both candidates and businesses.</p>
                        {/* <button type="button" className="home-page-btn1">Explore Now</button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
